import { useAuth } from "@/hooks/useAuth";

// Seth (2026-11-02): the new Partner Portal UI (the Dashboard-style menu, Home and Settings) is for MSD staff
// only, and impersonating anyone shows today's Portal. Paired with apps/backend/src/lib/new-ui.ts.
export const NEW_UI_EMAIL_DOMAIN = "merchantservicedepot.com";

export function canSeeNewUi(
  user: { userType: string; email: string } | null | undefined,
  impersonating: boolean,
): boolean {
  if (!user || impersonating) return false;
  return user.userType === "INTERNAL" && user.email.trim().toLowerCase().endsWith(`@${NEW_UI_EMAIL_DOMAIN}`);
}

export function useInternalUi(): boolean {
  const { user } = useAuth();
  return canSeeNewUi(user, !!user?.impersonating);
}
